export function TypingIndicator() {
  return (
    <div className="flex justify-start animate-message-appear">
      {/* DESIGN.md: flat assistant bubble — hairline, no drop shadow. */}
      <div className="px-4 py-3.5 rounded-message rounded-bl-md bg-white border border-neutral-200">
        <div className="flex items-center gap-1.5">
          <span
            className="w-2 h-2 rounded-full bg-primary/60 animate-typing-bounce"
            style={{ animationDelay: '0ms' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-primary/60 animate-typing-bounce"
            style={{ animationDelay: '200ms' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-primary/60 animate-typing-bounce"
            style={{ animationDelay: '400ms' }}
          />
        </div>
      </div>
    </div>
  )
}
